import { useHistory } from "react-router-dom";
import { useState, useCallback, useMemo } from "react";
import { useForm } from "./useForm";
import { useFetch } from "./useFetch";

export function useRdm(location) {
  const params = new URLSearchParams(location?.search || "");
  const history = useHistory();
  const [confirmSubmit, setConfirmSubmit] = useState(false);

  const [titleSearch, setTitleSearch] = useState(params.get("title") || "");
  const [typeFilter, setTypeFilter] = useState({
    creation: params.get("creation") === "true",
    page: params.get("page") ? parseInt(params.get("page")) : 1,
  });

  const setUrlParams = useCallback(
    ({ creation = typeFilter.creation, page = 1, title = titleSearch }) => {
      history.push({
        search:
          "?" +
          new URLSearchParams({
            title,
            creation,
            page,
          }).toString(),
      });
    },
    [history, titleSearch, typeFilter.creation]
  );

  const {
    title,
    setTitle,
    description,
    setDescription,
    form,
    handleClearForm,
  } = useForm();

  const {
    data,
    loading,
    totalPages,
    refetch,
    handleDebouncedSearchTitle,
    onCreate,
    onDelete,
    actualRdm,
    setActualRdm,
    openRemoveModal,
    setOpenRemoveModal,
  } = useFetch({
    titleSearch,
    typeFilter,
    setTypeFilter,
    setTitleSearch,
    setUrlParams,
  });

  const filterOptions = useMemo(
    () => [
      {
        value: typeFilter.creation,
        onChange: () => {
          setTypeFilter((prev) => ({
            creation: !prev.creation,
            page: 1,
          }));
        },
        label: "Ordem de criação",
      },
    ],
    [typeFilter.creation, setTypeFilter]
  );

  const [openModal, setOpenModal] = useState(false);

  const handleOpenRemove = (rdm) => {
    setOpenRemoveModal(true);
    setActualRdm(rdm);
  };
  const handleCloseRemove = () => {
    setOpenRemoveModal(false);
    setActualRdm(null);
  };

  const [openFilterOptions, setOpenFilterOptions] = useState(false);

  const selectNoneFilter = useCallback(() => {
    setTypeFilter({ creation: false, page: 1 });
    setUrlParams({ creation: false, page: 1 });
  }, [setUrlParams]);

  const updateFilters = useCallback(
    ({ creation = -1, page = 1 }) => {
      setTypeFilter({ creation, page });
      setUrlParams({ creation, page });
    },
    [setUrlParams]
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (confirmSubmit) return;
    setConfirmSubmit(true);
    await onCreate({ title, description });
    handleClearForm();
    setOpenModal(false);
    setConfirmSubmit(false);
  };

  const goToPanel = (id) => {
    history.push({
      pathname: `/rdmpanel/${id}`,
    });
  };
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  return {
    data,
    actualRdm,
    loading,
    totalPages,
    typeFilter,
    openModal,
    openRemoveModal,
    openFilterOptions,
    setOpenModal,
    setOpenFilterOptions,

    handleOpenModal,
    handleCloseModal,
    handleSubmit,
    handleOpenRemove,
    handleCloseRemove,
    handleDebouncedSearchTitle,

    titleSearch,
    setTitleSearch,
    filterOptions,
    selectNoneFilter,

    setUrlParams,
    updateFilters,
    refetch,

    onCreate,
    onDelete,
    form,
    title,
    setTitle,
    description,
    setDescription,
    handleClearForm,
    goToPanel,
  };
}
